import { useAccountsPayableContext } from 'templates/AccountsPayable/context'

import { FormCompanyScope } from 'components/CompanySelector'
import ModalMarkAsPaid from 'components/Modal/ModalMarkAsPaid'
import ModalNewExpense from 'components/Modal/ModalNewExpense'

/**
 * Modais que o `ModalDetailsExpenses` dispara pelo AccountsPayableContext: "Editar" e
 * "Duplicar" abrem o `ModalNewExpense`, "Marcar como paga" abre o `ModalMarkAsPaid`.
 *
 * Existe como componente próprio porque o modal de detalhe é aberto de cinco telas — a
 * lista de Contas a pagar, a busca global, o Fluxo de caixa, a Conciliação bancária e o
 * painel de falhas do Conta Azul — e cada uma monta seu próprio `AccountsPayableProvider`.
 * Os botões só chamam `setExpenseFormModal` / `setExpenseMarkAsPaidModal`; quem renderiza
 * é a tela. Como só a lista renderizava, nas outras quatro o clique setava o estado e
 * ninguém escutava: o botão não fazia absolutamente nada, sem erro e sem requisição.
 *
 * Toda tela que montar o `ModalDetailsExpenses` precisa montar este componente ao lado,
 * dentro do mesmo Provider.
 */
const AccountsPayableActionModals = () => {
  const {
    expenseFormModal,
    setExpenseFormModal,
    expenseMarkAsPaidModal,
    setExpenseMarkAsPaidModal
  } = useAccountsPayableContext()

  return (
    <>
      {expenseFormModal.isOpen && (
        // SC-10999: na visão multi-empresas a criação escolhe a empresa no topo
        // do formulário; edição e duplicação ficam na empresa da conta
        <FormCompanyScope
          recordUuid={
            expenseFormModal.uuid || expenseFormModal.sourceUuid || undefined
          }
        >
          {(companySelector) => (
            <ModalNewExpense
              {...expenseFormModal}
              companySelector={companySelector}
              handleClose={() =>
                setExpenseFormModal({
                  isOpen: false,
                  uuid: '',
                  isRecurrence: false
                })
              }
            />
          )}
        </FormCompanyScope>
      )}
      {expenseMarkAsPaidModal.isOpen && (
        <ModalMarkAsPaid
          uuid={expenseMarkAsPaidModal.uuid as string}
          isOpen={expenseMarkAsPaidModal.isOpen}
          handleClose={setExpenseMarkAsPaidModal}
        />
      )}
    </>
  )
}

export default AccountsPayableActionModals
